import {Injectable} from '@angular/core';
import {BaseService} from '../../../../core/abstracts/base-service.abstract';
import {ReadableById} from '../../../../core/interfaces/base-service.interfaces';
import {VehicleModelResponse} from '../model/vehicle-model-response.model';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class VehicleModelService extends BaseService implements ReadableById<VehicleModelResponse[]> {
  protected override endpoint: string = 'models';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  public getById(id: number | string): Observable<VehicleModelResponse[]> {
    return this.get<VehicleModelResponse[]>(id);
  }
}
